import { render, staticRenderFns } from "./index.vue?vue&type=template&id=72613470"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProjectLink: require('D:/private/personal-finance/src/components/Common/ProjectLink.vue').default,CustomerSupport: require('D:/private/personal-finance/src/components/Common/CustomerSupport.vue').default})
